function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconceBlog = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.9,
    height: 11.756,
    viewBox: "0 0 10.9 11.756",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.127 3v5.134l.05.075L8.4 9.912l.033.058.224.349 1.1 1.72h-.6l-.075.066-1.689 1.479v-1.545H6.6a1.041 1.041 0 0 1-1.063-1.063V5.393A1.041 1.041 0 0 1 6.6 4.329h.266V3.8H6.6A1.592 1.592 0 0 0 5 5.393v5.583a1.592 1.592 0 0 0 1.6 1.6h.266v2.185l.44-.39 2.052-1.795H14.3a1.592 1.592 0 0 0 1.6-1.6V5.393a1.592 1.592 0 0 0-1.6-1.6h-3.983V3zm.532.532h2.126v3.855L8.822 7l-.1-.033-.1.033-.964.382zm2.659.8H14.3a1.041 1.041 0 0 1 1.063 1.063v4.52H9.054l1.213-1.7.05-.075zm-1.6 3.215 1.055.424-.623.881h-.86l-.623-.881zm.64 2.9h6.007v.532a1.041 1.041 0 0 1-1.065 1.06h-3.93z",
    transform: "translate(-5 -3)",
    style: {
      fill: "#5a5a5a"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconceBlog);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.ce-blog.a4bb42ec4d3e47d3df75dd1ba7084700.svg";